import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import SmoothScroll from "@/lib/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { trackEvent } from "@/lib/track";

import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import Mission from "@/components/site/Mission";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Pricing from "@/components/site/Pricing";
import AdvisoryTeaser from "@/components/site/AdvisoryTeaser";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import AdminLeads from "@/components/site/AdminLeads";
import ThankYou from "@/components/site/ThankYou";
import PaymentCancel from "@/components/site/PaymentCancel";
import Login from "@/components/site/Login";
import AdvisoryPage from "@/components/advisory/AdvisoryPage";

function Home() {
  useEffect(() => {
    trackEvent("view", "home");
  }, []);

  return (
    <SmoothScroll>
      <div className="relative bg-background">
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <Mission />
          <Services />
          <Process />
          <Pricing />
          <AdvisoryTeaser />
          <Contact />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen bg-[var(--charcoal)] flex items-center justify-center">
        <Loader2 className="animate-spin text-[var(--gold-soft)]" size={30} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hospitality-advisory" element={<AdvisoryPage />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLeads />
                </ProtectedRoute>
              }
            />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
